@if (stateRateDescription) {
  <div id="stateRateInfo" class="container">
    <div>
      <h2>{{stateRateDescription.state}} Mortgage Rates </h2>
      @if (hook) {
        <div [innerHTML]="hook"></div>
      }
      <h3>
        Common {{stateRateDescription.state}} Loan Types:
      </h3>
      <ul style="list-style-type: disc; margin-left: 30px;">
        @if (conventionalInfo) {
          <li [innerHTML]="conventionalInfo"></li>
        }
        @if (!conventionalInfo) {
          <li>
            <b>{{stateRateDescription.state}} conventional mortgages:</b> {{stateRateDescription.state}} mortgage
            requirements
            and rates vary based on the area you live in, or want to live in, and your financial situation.
            <a href="https://www.freerateupdate.com/mortgage-rates">Compare mortgage rates </a> on FreeRateUpdate.com
            to find the option that's right for you.
          </li>
        }
        @if (fhaInfo) {
          <li [innerHTML]="fhaInfo"></li>
        }
        @if (!fhaInfo) {
          <li>
            <b>{{stateRateDescription.state}} FHA loans:</b> Home loans backed by the FHA are offered throughout the
            U.S.
            The FHA doesn't offer loans directly, you can find one through an FHA-approved lender in
            {{stateRateDescription.state}}
            on FreeRateUpdate.com today. FHA loans are typically offered to first-time homebuyers. FHA loans are
            designed for low- to moderate-income borrowers with lower credit scores.
          </li>
        }
        @if (vaInfo) {
          <li [innerHTML]="vaInfo"></li>
        }
        @if (!vaInfo) {
          <li>
            <b>{{stateRateDescription.state}} VA loans:</b> VA loans are backed by the Department of Veterans
            Affairs; VA loans are offered to eligible active duty service members and veterans. The VA doesn't offer loans directly,
            but you can find one through a VA-approved lender in {{stateRateDescription.state}} through
            FreeRateUpdate.com. VA loans require no
            down payment and typically have lower interest rates than conventional mortgages.
          </li>
        }
      </ul>
      <h3>{{stateRateDescription.state}} Mortgage Rates Compared to National Averages</h3>
      <p [innerHTML]="stateRateDescription.comparison"></p>
    </div>
  </div>
}